import React from 'react';
import styled from 'styled-components';

import EventsResult from './EventsResult';
import PeriodsResult from './PeriodsResult';
import EventsExecutionOptionsBar from './EventExecutionOptionsBar';
import { views } from '../../constants/event';
import EventTableView from '../table/EventTableView';
import { combineEventsWithSameUniqueChar, isAdditionalPeriods } from '../../utils/event/common';

const StyledTableView = styled(EventTableView)`
  width: 100%;
  height: calc(100% - (81px + 22px));
  display: flex;
  flex-direction: column;

  .enhanced-table {
    height: 100%;
    width: 100%;
  }
`;

const Result = (props) => {
  const { result, options } = props;

  const combinedEventsWithSameUniqueChar = combineEventsWithSameUniqueChar(result);

  const eventsWithAdditionalPeriods = combinedEventsWithSameUniqueChar.reduce(
    (acc, res) => (isAdditionalPeriods(res) ? [...acc, ...res] : acc),
    []
  );

  const eventsWithoutAdditionalPeriods = combinedEventsWithSameUniqueChar.reduce(
    (acc, res) => (!isAdditionalPeriods(res) ? [...acc, ...res] : acc),
    []
  );

  const eventsDataWithUniqueCharA = [
    eventsWithAdditionalPeriods,
    eventsWithoutAdditionalPeriods,
  ].find((events) => events.some(({ info }) => info.uniqueChar.includes('A')));

  const eventsDataWithoutUniqueCharA = [
    eventsWithAdditionalPeriods,
    eventsWithoutAdditionalPeriods,
  ].find((events) => events.every(({ info }) => !info.uniqueChar.includes('A')));

  const notEmptyEvents = [eventsDataWithUniqueCharA, eventsDataWithoutUniqueCharA].filter(
    (events) => events?.length
  );

  return (
    <>
      <EventsExecutionOptionsBar {...props} />
      {options.view === views.TABLE ? (
        <StyledTableView {...props} showTabs />
      ) : (
        <div>
          {notEmptyEvents.map((eventsResult) =>
            isAdditionalPeriods(eventsResult) ? (
              <PeriodsResult
                {...props}
                result={eventsResult}
                key={eventsResult[0].info.uniqueChar}
                height="400px"
                showSort
              />
            ) : (
              <EventsResult
                {...props}
                result={eventsResult}
                key={eventsResult[0].info.uniqueChar}
                height="400px"
                showSort
              />
            )
          )}
        </div>
      )}
    </>
  );
};

export default Result;
